export default "__VITE_ASSET__Dpz9SSTN__"